import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'
import type { Settings } from '@/types'

import Head from 'next/head'
import { IBM_Plex_Mono, IBM_Plex_Sans } from 'next/font/google'
import { Toaster } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'
import { SettingsProvider } from '@/components/generals/settings-provider'
import { InventoryActionsProvider } from '@/components/inventory/inventory-actions'

const sans = IBM_Plex_Sans({
    subsets: ['latin'],
    weight: ['400', '500', '600', '700']
})

const mono = IBM_Plex_Mono({
    subsets: ['latin'],
    weight: ['400', '500']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${sans.style.fontFamily}}`

type PageProps = {
    settings?: Settings
}

const App: FC<AppProps<PageProps>> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <meta key='viewport' name='viewport' content='width=device-width, initial-scale=1' />
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <SettingsProvider settings={pageProps.settings}>
                <TooltipProvider delay={250}>
                    <InventoryActionsProvider>
                        <Component {...pageProps} />
                    </InventoryActionsProvider>
                </TooltipProvider>

                <Toaster position='bottom-right' closeButton />
            </SettingsProvider>
        </div>
    )
}

export default App
